import { render } from "./ProductEditPage.vue?vue&type=template&id=975c53ce"
import script from "./ProductEditPage.vue?vue&type=script&lang=js"
export * from "./ProductEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__